import React from 'react'

const SmallSpinner = ({ size = 16, color = '#007bff' }) => {
  return (
    <div
      className="spinner-border spinner-border-sm"
      role="status"
      style={{
        width: `${size}px`,
        height: `${size}px`,
        borderWidth: `${size / 8}px`,
        color,
      }}
    >
      <span className="visually-hidden"></span>
    </div>
  )
}

export default SmallSpinner
